import styled from 'styled-components';

import { inputPlaceholder } from '../../helpers/style-helpers';
import { inputBase } from '../input/input.styled';
import theme from '../../constants/theme';

export type TPasswordInputSC = {
  mb?: number;
  error?: string | boolean;
};

export default styled.div<TPasswordInputSC>`
  margin-bottom: ${({ mb }) => (mb ? `${mb}px` : `${mb}px`)};

  div {
    display: flex;
    position: relative;

    button {
      background-color: ${theme.colors.inputBg};
      border-width: 0;
      outline: none;

      img {
        margin-right: 10px;
      }
    }

    input {
      ${inputBase}
      ${({ error }) => inputPlaceholder(error ? theme.colors.error : '#c2c2ce')}

      height: 50px;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
      background: ${({ error }) => (error ? '#ffeaee' : theme.colors.inputBg)};
      padding-left: 16px;
      padding-right: 16px;
      color: ${({ error }) => (error ? theme.colors.error : theme.colors.font)};
    }

    div {
      display: flex;
      align-items: center;
      background: ${({ error }) => (error ? '#ffeaee' : theme.colors.inputBg)};
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      padding-right: 16px;

      label {
        display: block;
        margin-bottom: 0;
        font-size: 14px;
        color: ${({ error }) => (error ? theme.colors.error : '#293157')};
        opacity: 0.6;
        width: max-content;
      }
    }
  }
`;
